export default {
  view: 'core.view_bank',
  add: 'core.add_bank',
  change: 'core.change_bank',
  delete: 'core.delete_bank',
  export: 'core.export_bank',
};
